<template>
    <div class="">
        <ul class="status_list">
            <li v-for="(item,i) in statusList" :key="i" :class="{'active': item.status == status}"
                @click="changeStatus(item.status)">{{ item.name }}</li>
        </ul>
        <div class="record_goods_list">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <order-scroll :url="url" :params="params" ref="manage" @on-fetch="fetch">
                    <template slot-scope="scope">
                        <div v-for="(item,i) in scope.data" :key="i">
                            <manage-item :info="item" :status_maps="status_maps"/>
                        </div>
                    </template>
                </order-scroll>
            </van-pull-refresh>
        </div>
    </div>
</template>

<script>
    import ManageItem from './order/ManageItem.vue'
    export default {
        components: {
            ManageItem
        },
        data() {
            return {
                isLoading: false,
                statusList: [{
                        status: 0,
                        name: '全部'
                    },
                    {
                        status: 1,
                        name: '待审核'
                    },
                    {
                        status: 2,
                        name: '上架中'
                    },
                ],
                url: 'goods-role/manage',
                params: {},
                status_maps: {}
            }
        },
        computed: {
            status() {
                return this.$route.params.status
            }
        },
        created() {},
        mounted() {

        },
        methods: {
            onRefresh() {
                setTimeout(() => {
                    this.isLoading = false;
                    this.$refs.manage.refresh()
                }, 1000);
            },
            changeStatus(status) {
                if (status == this.status) return
                this.$router.replace({
                    name: 'user.goods',
                    params: {
                        status
                    }
                })
                this.$refs.manage.refresh()
            },
            fetch(e) {
                this.status_maps = e.status_maps
            }
        },
        watch: {
            status: {
                immediate: true,
                handler(s) {
                    if (s == 1) {
                        this.params.status = 3
                    } else if (s == 2) {
                        this.params.status = 1
                    } else if (s == 0) {
                        this.params = {}
                    }
                }
            }
        },
    }
</script>

<style lang="less" scoped>
    .status_list {
        position: fixed;
        width: 100%;
        max-width: 525px;
        top: 5rem;
        left: 50%;
        transform: translateX(-50%);
        background-color: var(--innerbgc);
        height: 4rem;
        padding: 0 2rem;
        display: flex;
        align-items: center;
        z-index: 10;

        li {
            font-size: 1.6rem;
            color: #000;
            margin-right: 3rem;
            cursor: pointer;

            &.active {
                font-weight: 700;
                color: var(--theme);
            }
        }
    }
    .record_goods_list {
        padding-top: 6rem;
    }
</style>